<template>
  <spinner-container :loading="localLoading">
    <back-btn/>

    <v-row justify="center">
      <v-col cols="12" md="6">
        <pa-form :pa="pa" @emitPaData="updatePA" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import PaForm from "@/components/pa/PaForm";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    PaForm,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({
   
  }),
  computed: {
    ...mapState("Pa", ["pa"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    updatePA(payload) {
      this.$store.dispatch("Pa/updatePA", payload).then(() => {
        this.$router.push({ name: "pa" });
      });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");

    this.$store.dispatch("Pa/getPA", this.$route.params.id).then(() => {
      this.$store.dispatch("Loading/changeLocalLoading");
    });
  },
};
</script>
